define('views/CaseStudiesView',[
    'backbone',
    'lodash',
    'text!templates/casestudies.html',
    'app',
    'lib/MouseAnim'
], function (Backbone, _, caseStudiesTmpl, App, MouseAnim) {

    "use strict";

    return Backbone.View.extend({

        tagName: 'article',

        template: _.template(caseStudiesTmpl),

        render: function () {
            this.$el.html(this.template(App));

            if (App.caseStudies.length) {
                this.initAnim();
            }
        },

        initAnim: function () {
            var $projects = this.$el.find('.project');

            this.mouseAnim = new MouseAnim();
            this.mouseAnim.add(function (pos) {
                var halfSrnW = window.innerWidth/2,
                    x = pos.mousePos.x / window.innerWidth,
                    height = $projects[0].offsetHeight, // height of image
                    midPt = height * (1 - x), // intercept pt of divide line and middle y-axis
                    AR = 1.468,
                    clearW = $projects[0].offsetWidth * 0.6;

                // left col
                var rightBottom = Math.round((height - midPt) / AR),
                    left = {
                        leftTop: halfSrnW - rightBottom - clearW,
                        rightBottom: rightBottom,
                        append: halfSrnW - rightBottom
                    };

                // right col
                var leftTop = Math.round(midPt / AR),
                    right = {
                        leftTop: leftTop,
                        rightBottom: halfSrnW - leftTop - clearW,
                        append: leftTop + clearW
                    };

                $projects.each(function (i, e) {
                    var tri = $(e).find('.right-tri'),
                        widths = i%2 ? right : left;

                    tri[0].style.width = widths.leftTop <= 0 ? 0 : widths.leftTop + 'px';
                    tri[1].style.width = widths.rightBottom <= 0 ? 0 : widths.rightBottom + 'px';
                    tri[2].style.width = widths.append <= 0 ? 0 : widths.append + 'px';
                });
            });
        },

        remove: function () {
            if (this.mouseAnim) {
                this.mouseAnim.destroy();
            }
            Backbone.View.prototype.remove.call(this);
        }
    });

});
